var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 564.76 386.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:137px;fill:red;letter-spacing:-0.03em;}.cls-1,.cls-3{font-family:Calibri-Bold, Calibri;font-weight:700;}.cls-2{letter-spacing:-0.05em;}.cls-3{font-size:53px;fill:#3900ff;letter-spacing:-0.07em;}.cls-4{letter-spacing:-0.07em;}.cls-5{letter-spacing:-0.08em;}.cls-6{letter-spacing:-0.07em;}.cls-7{letter-spacing:-0.07em;}.cls-8{letter-spacing:-0.09em;}.cls-9{letter-spacing:-0.08em;}.cls-10{letter-spacing:-0.08em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.91,465.54s-.52-17.4,28.18-32.18c0,0,13.56-6.4,80.87-12.42,0,0,81.91-6.53,109.56-34.18,0,0-2.61,32.87-67.3,59.48,0,0,45.39,15.13,80.35-59.48,0,0,14.08,29.74-29.74,72,0,0,29.21,3.13,44.87-62.09,0,0,9.91-34.43,39.65-42.78,0,0,147.65-49.83,193.56-117,0,0-5.21,30.39-57.39,74.74,0,0-29.74,24-106.95,53.74,0,0-40.7,9.39-53.22,63.13,0,0-13.57,68.87-84,124.17,0,0-37,27.65-37.57,70.44,0,0-18.26-11.48-38.61-57.92,0,0-14.6-45.91-42.78-40.17,0,0,5.87,3.65-7.43,15,0,0-16.83,4.7-31.31,27l-2,15.65a38.2,38.2,0,0,1-18.79,5.48C36.57,588.54,24,576.41,24,576.41l7.83-26.61S42,513.41,35.39,498.54a39.12,39.12,0,0,1,5.09-16.43s-9-7.83-13.31-23.09l5.09,1.17-1.56-5.08S44.39,461.89,47.91,465.54Z",
    transform: "translate(-24.04 -236.89)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7,570.54S370,532.19,312.43,506.76c0,0,32.09-4.31,50.48,7.43s-58.3,47.35-79.82,50.09S237.7,570.54,237.7,570.54Z",
    transform: "translate(-24.04 -236.89)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M314.39,500.11s26.22-15.66,57.13-9,59.87,12.05,67.7,3.67c0,0-10.18,21-58.7,13.94C380.52,508.72,340.22,493.06,314.39,500.11Z",
    transform: "translate(-24.04 -236.89)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M456.31,461.15a135.3,135.3,0,0,1-13.71,5c-28.33,8.52-54.34,6.06-72.64,2.12a63.88,63.88,0,0,0-16.58,1,65.67,65.67,0,0,0-29.21,14,66.53,66.53,0,0,1,46.57-2.35,93.24,93.24,0,0,0,36.54,2.45A95.08,95.08,0,0,0,456.31,461.15Z",
    transform: "translate(-24.04 -236.89)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M478.74,413.24s-6.65,28.17-48.52,36c0,0-80.22,5.87-87.26,11.35,0,0,7-17.22,45.78-20.74C388.74,439.85,473.26,426.93,478.74,413.24Z",
    transform: "translate(-24.04 -236.89)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M509.55,299.15a154.56,154.56,0,0,1-16.33,18.48c-27.31,26.31-58.58,36.95-78.65,41.61,0,0-77.48,18.78-86.48,64.17,0,0,23.87-29,101.34-51.26a106.72,106.72,0,0,0,40-17.41C496.25,335.61,506.28,309.27,509.55,299.15Z",
    transform: "translate(-24.04 -236.89)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M334.74,442.19s10.18-28.95,56.16-38.34c0,0,78.06-14.09,102.32-41.48a66.28,66.28,0,0,1-7.44,16.19c-10,15.8-24.34,23.27-31.48,26.36-5.3,1.48-13.33,3.66-23.17,6.1-17,4.21-29.24,6.66-32.95,7.45C384.63,421.34,364.21,427.52,334.74,442.19Z",
    transform: "translate(-24.04 -236.89)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(125.61 319.33)"
  }, "P", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 68.53,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 128.97,
    y: 0
  }, "GASO"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(196.83 358.3)"
  }, "soci", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 70.84,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 93.66,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 108.02,
    y: 0
  }, "\xE0 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 139.17,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 157.59,
    y: 0
  }, "oope"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 255.71,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 269.88,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 292.06,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 319.59,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 340.39,
    y: 0
  }, "a"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/LogoSmall.5e9a7ec636795decf8fa364627e51f1b.svg";
export { ForwardRef as ReactComponent };